import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class BannerComponent {
    constructor() {
        BannerComponent.init()
    }

    static async init() {
        const videoContainer = '[data-customer-video="banner"]'
        const swiperContainer = '[data-customer-slider="banner"]'

        // Show banner video only on desktop
        if ($(videoContainer).length > 0 && window.matchMedia('(min-width: 1001px)').matches) {
            const videoElmt = document.createElement('video')
            const videoSrc = document.createElement('source')

            // config
            videoSrc.type = $(videoContainer).data('customer-video-type')
            videoSrc.src = $(videoContainer).data('customer-video-src')
            videoElmt.muted = true
            videoElmt.loop = true

            videoElmt.appendChild(videoSrc)
            $(videoContainer).append(videoElmt)
            videoElmt.play()
        } else if ($(swiperContainer).length > 0) {
            const options = {
                slidesPerView: 'auto',
                autoplay: {
                    delay: 3000,
                },
                pagination: {
                    el: '#swiper-banner-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: '#swiper-banner-next',
                    prevEl: '#swiper-banner-prev',
                },
                mousewheel: {
                    forceToAxis: true,
                },
                grabCursor: true,
                loop: true,
            }

            // insert navigation / pagination
            // $(swiperContainer).append('<span id="swiper-banner-prev" class="customer-slider-button-prev"></span><span id="swiper-banner-next" class="customer-slider-button-next"></span><span id="swiper-banner-pagination" class="customer-slider-pagination"></span>');
            $(`${swiperContainer}> *`)
                .wrapAll('<div class="swiper-wrapper"></div>')
                .addClass('swiper-slide')

            await Swiper.create(swiperContainer, options)
        }
    }
}
